"use strict";

export function ucFirst() {
  return function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
}

export function priceDollar() {
  return function(price) {
    price = price.toString();
    if (price.indexOf(".") < 0) return price;

    return price.split(".")[0];
  };
}

export function priceCents() {
  return function(price) {
    price = price.toString();
    if (price.indexOf(".") < 0) return price;
    return price.split(".")[1];
  };
}

export function videoTime() {
  return function(mediaInfoVideoLength) {
    const seconds = Math.floor(mediaInfoVideoLength / 1000);
    const times = Array("s", "m", "h").map((x, i) => {
      const time = Math.floor((seconds % 60 ** (i + 1)) / 60 ** i);
      return time < 10 ? `0${time}` : time;
    });

    return times.reverse().join(":");
  };
}



// WEBPACK FOOTER //
// ./~/site_core/src/filters/global.js